import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import AppLoader from '../app-loader';
import LoadingModalSC from './index.styled';

class LoadingModal extends React.PureComponent {
  render() {
    const { visible} = this.props;
    // do not render it
    if (!visible) return null;

    return (
      <Modal
        open={visible}
        classNames={{
          modal: 'loading-modal',
          overlay: 'loading-overlay'
        }}
        showCloseIcon={false}
        closeOnOverlayClick={false}
      >
        <LoadingModalSC>
          <AppLoader size="" />
          {/* <span>{t('loadingModal.title')}</span> */}
        </LoadingModalSC>
      </Modal>
    );
  }
}

LoadingModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  // t: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  visible: state.ui.loadingModalVisible
});

export default connect(mapStateToProps)(LoadingModal);
